import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
    selector: '[dragScroll]',
    standalone: false
})
export class DragScrollDirective implements OnInit {
  slider: any;
  isDown: boolean = false;
  startX: any;
  scrollLeft: any;

  constructor(private _el: ElementRef) {}

  ngOnInit() {
    this.slider = this._el.nativeElement;
  }

  @HostListener('mousedown', ['$event'])
  onMousedown(event: any) {
    this.isDown = true;
    this.startX = event.pageX - this.slider.offsetLeft;
    this.scrollLeft = this.slider.scrollLeft;
  }

  @HostListener('mouseleave')
  onMouseleave() {
    this.isDown = false;
  }

  @HostListener('mouseup')
  onMouseup() {
    this.isDown = false;
  }

  @HostListener('mousemove', ['$event'])
  onMousemove(event: any) {
    if (!this.isDown) {
      return;
    }
    event.preventDefault();
    const x = event.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX) * 3;
    this.slider.scrollLeft = this.scrollLeft - walk;
  }
}
